import React from 'react';
import { Link } from 'react-router';
import { styled } from '@mui/material/styles';
import { Grid, Paper, Container, Typography, Button } from '@mui/material';

const PREFIX = 'DeniedComponent';

const classes = {
  gridContainer: `${PREFIX}-gridContainer`,
  paper: `${PREFIX}-paper`,
};

const StyledContainer = styled(Container)({
  [`& .${classes.gridContainer}`]: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  },
  [`& .${classes.paper}`]: {
    padding: '20px',
    width: '90%',
    maxWidth: '400px',
  },
});

/**
 * @param {Object} props
 * @param {string} props.heading
 * @param {string} props.fieldText
 * @param {string} props.buttonHref
 * @param {string} props.buttonText
 * @returns {JSX.Element} The rendered account creation component.
 */
export const DeniedComponent = ({ heading, fieldText, buttonHref, buttonText }) => (
  <StyledContainer maxWidth="sm">
    <Grid container className={classes.gridContainer}>
      <Paper className={classes.paper}>
        <Grid size={{ md: 12 }} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h5" align="center" gutterBottom>
            {heading}
          </Typography>
          <br />
          <Typography variant="body1" align="center">
            {fieldText}
          </Typography>
          <br />
          <Link to={buttonHref}>
            <Button variant="contained" color="primary">
              {buttonText}
            </Button>
          </Link>
        </Grid>
      </Paper>
    </Grid>
  </StyledContainer>
);
